class NotificationButton {
  private element: HTMLButtonElement;

  constructor(element: HTMLButtonElement) {
    this.element = element;

    this.setClickHandler = this.setClickHandler.bind(this);
    this.setIsNewStatus = this.setIsNewStatus.bind(this);
  }

  setIsNewStatus(isNew?: boolean) {
    if (isNew) {
      this.element.classList.add(`user__notifications--new`);
    } else {
      this.element.classList.remove(`user__notifications--new`);
    }
  }

  setClickHandler(callback) {
    this.element.addEventListener(`click`, callback);
  }
}

export {NotificationButton};
